const status = [
  { color: 'green', label: 'En linea', value: 'online' },
  { color: 'grey', label: 'Desconectado', value: 'offline' },
  { color: 'yellow', label: 'Ausente', value: 'away' },
  { color: 'red', label: 'No molestar', value: 'do_not_disturb' },
  { color: 'black', label: 'Invisible', value: 'invisible' }
]

export default status
